import { render, staticRenderFns } from "./CountWidget.vue?vue&type=template&id=90da44d2&scoped=true"
import script from "./CountWidget.vue?vue&type=script&lang=js"
export * from "./CountWidget.vue?vue&type=script&lang=js"
import style0 from "./CountWidget.vue?vue&type=style&index=0&id=90da44d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90da44d2",
  null
  
)

export default component.exports